"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  margin-top: ${props => props.theme.spacing.m5}px;
  width: 100%;
  display: flex;
  justify-content: center;
`;
exports.default = {
    Container: exports.Container
};
